﻿import * as paths from '../../../map/utils/paths'
import ApexCharts from 'apexcharts'
export default class ChartConfigurator {
    constructor(rootUrl, resourcesHandler, modalContainer, layerSettingsHandler, classId) {
        this.rootUrl = rootUrl;
        this.resourcesHandler = resourcesHandler;
        this.modalContainer = modalContainer
        this.layerSettingsHandler = layerSettingsHandler;
        this.classId = classId;
        this.cancelChartSettingsId = 'cancel-chart-settings-' + this.classId;
        this.saveChartSettingsId = 'save-chart-settings-' + this.classId;
        this.chartSettingsWrapper = 'chart-settings-wrapper-' + this.classId;
        this.propertySelectId = 'chart-settings-property-select-' + this.classId;
        this.chartTypeSelectId = 'chart-settings-chart-type-select-' + this.classId;
        this.chartOptionsSettingsContainer = 'chart-settings-options-container-' + this.classId
        this.samplingIntervalId = 'chart-settings-sampling-interval-' + this.classId;
        this.samplingMeasureId = 'chart-settings-sampling-measure-' + this.classId;
        this.sortingId = 'chart-settings-sorting-' + this.classId;
        this.colorPalleteId = 'chart-settings-color-pallete-' + this.classId;
        this.chartTypePie = 'chart-type-pie-' + this.classId; 
        this.chartTypeBar = 'chart-type-bar-' + this.classId; 
        this.chartTypeLine = 'chart-type-line-' + this.classId; 
        this.chartTypes = [
            {
                id: this.chartTypePie,
                name:'PieChart' 
            },
            {
                id: this.chartTypeBar,
                name: 'BarChart'
            },
            {
                id: this.chartTypeLine,
                name: 'LineChart'
            }
        ];
        this.samplingMeasuresDate = [
            {
                id: 'hour',
                name: this.resourcesHandler.get("Hour")
            },
            {
                id: 'day',
                name: this.resourcesHandler.get("Day")
            },
            {
                id: 'week',
                name: this.resourcesHandler.get("Week")
            },
            {
                id: 'month',
                name: this.resourcesHandler.get("Month")
            },
            {
                id: 'year',
                name: this.resourcesHandler.get("Year")
            }];
        this.sortingTypes = [
            {
                id: 'nosorting',
                name: this.resourcesHandler.get("NoSorting")
            },
            {
                id: 'asc',
                name: this.resourcesHandler.get("Ascendent")
            },
            {
                id: 'desc',
                name: this.resourcesHandler.get("Descendent")
            }]
        this.allowedDataTypes = ['int', 'double', 'string', 'dateTime', 'integer', 'date', 'numeric'];
        this.extractedFieldOptions = [];
        this.colorPalettes = [
            {
                id: 'retro-metro',
                name: 'Retro Metro',
                colors: ["#ea5545", "#f46a9b", "#ef9b20", "#edbf33", "#ede15b", "#bdcf32", "#87bc45", "#27aeef", "#b33dc6"]
            },
            {
                id: 'dutch-field',
                name: 'Dutch Field',
                colors: ["#e60049", "#0bb4ff", "#50e991", "#e6d800", "#9b19f5", "#ffa300", "#dc0ab4", "#b3d4ff", "#00bfa0"]
            },
            {
                id: 'river-nights',
                name: 'River Nights',
                colors: ["#b30000", "#7c1158", "#4421af", "#1a53ff", "#0d88e6", "#00b7c7", "#5ad45a", "#8be04e", "#ebdc78"]
            },
            {
                id: 'spring-pastels',
                name: 'Spring Pastels',
                colors: ["#fd7f6f", "#7eb0d5", "#b2e061", "#bd7ebe", "#ffb55a", "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7"]
            },
            {
                id: 'blue-to-yellow',
                name: 'Blue to Yellow',
                colors: ["#115f9a", "#1984c5", "#22a7f0", "#48b5c4", "#76c68f", "#a6d75b", "#c9e52f", "#d0ee11", "#d0f400"]
            },
            {
                id: 'grey-to-red',
                name: 'Grey to Red',
                colors: ["#d7e1ee", "#cbd6e4", "#bfcbdb", "#b3bfd1", "#a4a2a8", "#df8879", "#c86558", "#b04238", "#991f17"]
            },
            {
                id: 'black-to-pink',
                name: 'Black to Pink',
                colors: ["#2e2b28", "#3b3734", "#474440", "#54504c", "#6b506b", "#ab3da9", "#de25da", "#eb44e8", "#ff80ff"]
            },
            {
                id: 'blues',
                name: 'Blues',
                colors: ["#0000b3", "#0010d9", "#0020ff", "#0040ff", "#0060ff", "#0080ff", "#009fff", "#00bfff", "#00ffff"]
            },
            {
                id: 'blue-to-red',
                name: 'Blue to Red',
                colors: ["#1984c5", "#22a7f0", "#63bff0", "#a7d5ed", "#e2e2e2", "#e1a692", "#de6e56", "#e14b31", "#c23728"]
            },
            {
                id: 'orange-to-purple',
                name: 'Orange to Purple',
                colors: ["#ffb400", "#d2980d", "#a57c1b", "#786028", "#363445", "#48446e", "#5e569b", "#776bcd", "#9080ff"]
            },
            {
                id: 'pink-foam',
                name: 'Pink Foam',
                colors: ["#54bebe", "#76c8c8", "#98d1d1", "#badbdb", "#dedad2", "#e4bcad", "#df979e", "#d7658b", "#c80064"]
            },
            {
                id: 'salmon-to-aqua',
                name: 'Salmon to Aqua',
                colors: ["#e27c7c", "#a86464", "#6d4b4b", "#503f3f", "#333333", "#3c4e4b", "#466964", "#599e94", "#6cd4c5"]
            }
        ]
    }

    init() {
        this.extractedFieldOptions = [];
    }

    async addNewChart(layer) {
        if (layer) {
            let layerFields = await this._getLayerInfo(layer);
            let layerFieldOptions = [];
            layerFields.forEach(x => {
                let dataType = x.Attributes.find(a => a.Name == 'type');
                if (dataType) {
                    if (this.allowedDataTypes.includes(dataType.Value.replace("xsd:", "").toLocaleLowerCase())) {
                        layerFieldOptions.push({
                            Name: x.Name + ` (${dataType.Value.replace("xsd:", "")})`,
                            Id: x.Name,
                            Type: dataType.Value.replace("xsd:", "")
                        });
                    }
                }
            });
            this.extractedFieldOptions = layerFieldOptions;

            this._initChartSettingsPanel();
            this._setChartInterfaceListeners();
        }
    }

    _initChartSettingsPanel() {
        this.modalContainer.innerHTML = this._getChartSettingsTemplate();
        this._initSettingsControls();
    }

    _initSettingsControls() {
        //Layer Field Selection
        $('#' + this.propertySelectId).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            appendTo: '#' + this.propertySelectId,
            dataSource: this.extractedFieldOptions,
            change: (e) => {
                let value = e.sender.value();
                this._initChartSettingsOptionsFor(value);
            }
        });

        //Chart Type Selection
        this.chartTypes.forEach(chartType => {
            switch (chartType.name) {
                case "PieChart": {
                    let options = {
                        chart: {
                            type: 'pie',
                            animations: {
                                enabled: false
                            },
                            zoom: {
                                enabled: false
                            },
                            toolbar: {
                                show: false
                            }

                        },
                        series: [44, 55, 13, 33],
                        dataLabels: {
                            enabled: false
                        },
                        legend: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        }
                    }

                    this._renderChartOptionItem(chartType, options);

                    break;
                }
                case "BarChart": {
                    let options = {
                        chart: {
                            type: 'bar',
                            animations: {
                                enabled: false
                            },
                            zoom: {
                                enabled: false
                            },
                            toolbar: {
                                show: false
                            }
                        },
                        series: [{
                            name: 'sales',
                            data: [30, 45, 50, 70, 125]
                        }],
                        yaxis: {
                            labels: {
                                show: false
                            }
                        },
                        xaxis: {
                            categories: [1, 2, 4, 7, 9],
                            labels: {
                                show: false
                            }
                        },
                        dataLabels: {
                            enabled: false
                        },
                        legend: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        },
                        animations: {
                            enabled: false
                        }
                    }

                    this._renderChartOptionItem(chartType, options);

                    break;
                }
                case "LineChart": {
                    let options = {
                        chart: {
                            type: 'line',
                            animations: {
                                enabled: false
                            },
                            zoom: {
                                enabled: false
                            },
                            toolbar: {
                                show: false
                            }
                            
                        },
                        series: [{
                            name: 'sales',
                            data: [30, 45, 50, 70, 125]
                        }],
                        yaxis: {
                            labels: {
                                show: false
                            }
                        },
                        xaxis: {
                            categories: [1, 2, 4, 7, 9],
                            labels: {
                                show: false
                            }
                        },
                        markers: {
                            size: 2,
                        },
                        dataLabels: {
                            enabled: false
                        },
                        legend: {
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        }
                    }

                    this._renderChartOptionItem(chartType, options);
                    break;
                }
            }
        });

    };

    _renderChartOptionItem(chartType, options) {

        let chart = document.createElement("div");
        chart.id = chartType.id + '-render';
        chart.style.height = '200px';
        chart.style.width = '200px';
        chart.style.visibility = 'invisible';
        chart.classList.add('m-2');

        let chartOptionItem = document.createElement("div")
        chartOptionItem.id = chartType.id;
        chartOptionItem.style.height = '100px';
        chartOptionItem.style.width = '100px';
        chartOptionItem.style.visibility = 'invisible';
        chartOptionItem.style.border = '1px solid #E5E5E5';
        chartOptionItem.style.borderRadius = '4px';
        chartOptionItem.classList.add(...['m-2', 'd-flex', 'justify-content-center', 'align-items-center']);

        $(`#${this.chartTypeSelectId}`).append(chart);
        $(`#${this.chartTypeSelectId}`).append(chartOptionItem);

        let apexChart = new ApexCharts(document.querySelector(`#${chartType.id}-render`), options);
        apexChart.render().then(() => {
            apexChart.dataURI().then(({ imgURI }) => {
                let containerChart = document.getElementById(chartType.id);
                let imgChart = document.createElement("img");
                imgChart.src = imgURI;
                imgChart.style.width = '90px';
                containerChart.appendChild(imgChart);
                containerChart.style.visibility = 'visible';

                $(`#${chartType.id}-render`).remove();
            });
        })
    }

    _getChartSettingsTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row general-settings-title-row m-0">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('ChartConfiguration') + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this.resourcesHandler.get('PropertySelect') + `</label>
                                        <input class="form-control" id="` + this.propertySelectId + `">
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this.resourcesHandler.get('ChartType') + `</label>
                                        <div class="d-flex flex-row p-2 mx-4 mt-2" id="` + this.chartTypeSelectId + `">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class='d-flex flex-column' id="` + this.chartOptionsSettingsContainer + `">
                                <label class="form-label">` + this.resourcesHandler.get('DataConfig') + `</label>
                                
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveChartSettingsId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanged') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    async _getLayerInfo(layer) {
        if (Object.keys(layer).find(x => x.toLocaleLowerCase() == 'geoservice')) {
            //geoservice type - obtain item type from geoservice
            let response = await fetch(this.rootUrl + paths.MAP_GEOSERVICE_FIELDS_DESCRIPTOR + layer.IdGeoService, {
                method: "GET"
            });

            let json = await response.json();
            return json;
        } else if(Object.keys(layer).find(x => x.toLocaleLowerCase() == 'entity')){
            let entityId = layer.Entity.Id;

            let response = await fetch(this.rootUrl + paths.MAP_ENTITY_GET_FIELDS + entityId, {
                method: "GET"
            });

            let json = await response.json();

            let fields = [];

            json.forEach(x => {
                fields.push({
                    Name: x.FieldName,
                    Attributes: [{
                        Name: 'type',
                        Value: x.DataType
                    }]
                });
            });

            return fields;
        }
        return [];
    }

    _onChartTypeSelected(chartTypeId) {
        this.chartTypes.forEach(chartOpts => {
            let selector = document.getElementById(chartOpts.id);
            if (selector.classList.contains('chart-type-selected')) {
                selector.classList.remove('chart-type-selected');
                //is selected
                if (chartOpts.id == chartTypeId) {
                    //just deselect is ok
                }
            }
            else {
                //is not selected
                if (chartOpts.id == chartTypeId) {
                    //select this one
                    selector.classList.add('chart-type-selected');
                }
            }
        });
    }

    _setChartInterfaceListeners(layer) {
        //CANCEL FORM
        $(`#${this.cancelChartSettingsId}`).on("click", () => {
            document.getElementById(this.chartSettingsWrapper).remove();
        });

        //SAVE FORM
        $(`#${this.saveChartSettingsId}`).on("click", () => {
            this.layer.Charts = [];

            document.getElementById(this.chartSettingsWrapper).remove();
        });


        //ON CHART TYPE 
        //SETTING LISTENERS
        $(`#${this.chartTypePie}`).click(() => {
            this._onChartTypeSelected(this.chartTypePie);
        })
        $(`#${this.chartTypeBar}`).click(() => {
            this._onChartTypeSelected(this.chartTypeBar);
        })
        $(`#${this.chartTypeLine}`).click(() => {
            this._onChartTypeSelected(this.chartTypeLine);
        })
    }

    _initChartSettingsOptionsFor(key) {

        let optionsContainer = document.getElementById(this.chartOptionsSettingsContainer);
        optionsContainer.innerHTML = '';

        let item = this.extractedFieldOptions.find(x => x.Id == key);
        if (item) {
            if (item.Type == 'string') {
                //no more options?
                //collor pallete
                this._addSortingOption();
            } else if (item.Type == 'int') {
                this._addSamplingIntervalForInt();
                this._addSortingOption();
            } else if (item.Type == 'double') {
                this._addSamplingIntervalForInt();
                this._addSortingOption();
            } else if (item.Type == 'dateTime') {
                this._addSamplingIntervalForDate();
                this._addSortingOption();
            }

            this._addColorPalleteOptions();
        }
    }

    _addSamplingIntervalForDate() {
        let container = document.createElement("div");
        container.classList.add(...['form-row', 'mb-0']);

        //sampling size
        {
            let containerColumn = document.createElement("div");
            containerColumn.classList.add(...['col-xl-6', 'mb-3']);
            container.append(containerColumn);

            let formGroup = document.createElement("div");
            formGroup.classList.add(...['form-group']);
            containerColumn.append(formGroup);

            let label = document.createElement("label");
            label.classList.add(...['form-label']);
            label.textContent = this.resourcesHandler.get('SamplingInterval');
            formGroup.append(label);

            let input = document.createElement("input");
            input.classList.add(...['form-control']);
            input.id = this.samplingIntervalId;
            formGroup.append(input);
        }

        //sampling type
        {
            let containerColumn = document.createElement("div");
            containerColumn.classList.add(...['col-xl-6', 'mb-3']);
            container.append(containerColumn);

            let formGroup = document.createElement("div");
            formGroup.classList.add(...['form-group']);
            containerColumn.append(formGroup);

            let label = document.createElement("label");
            label.classList.add(...['form-label']);
            label.textContent = this.resourcesHandler.get('SamplingInterval');
            formGroup.append(label);

            let inputMeasure = document.createElement("input");
            inputMeasure.classList.add(...['form-control']);
            inputMeasure.id = this.samplingMeasureId;
            formGroup.append(inputMeasure);
        }

        let optionsContainer = document.getElementById(this.chartOptionsSettingsContainer);
        optionsContainer.appendChild(container);

        //INIT
        $("#" + this.samplingIntervalId).kendoNumericTextBox({
            appendTo: '#' + this.samplingIntervalId
        });

        $('#' + this.samplingMeasureId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            syncValueAndText: false,
            ignoreCase: true,
            appendTo: '#' + this.samplingMeasureId,
            dataSource: this.samplingMeasuresDate,
            change: (e) => {
                let value = e.sender.value();
                console.log(value);
            }
        });
    }

    _addSamplingIntervalForInt() {
        let container = document.createElement("div");
        container.classList.add(...['form-row', 'mb-0']);

        let containerColumn = document.createElement("div");
        containerColumn.classList.add(...['col-xl-12', 'mb-3']);
        container.append(containerColumn);

        let formGroup = document.createElement("div");
        formGroup.classList.add(...['form-group']);
        containerColumn.append(formGroup);

        let label = document.createElement("label");
        label.classList.add(...['form-label']);
        label.textContent = this.resourcesHandler.get('SamplingInterval');
        formGroup.append(label);

        let input = document.createElement("input");
        input.classList.add(...['form-control']);
        input.id = this.samplingIntervalId;
        formGroup.append(input);

        let optionsContainer = document.getElementById(this.chartOptionsSettingsContainer);
        optionsContainer.appendChild(container);

        //INIT
        $("#" + this.samplingIntervalId).kendoNumericTextBox({
            appendTo: '#' + this.samplingIntervalId
        });
    }

    _addSortingOption() {
        let container = document.createElement("div");
        container.classList.add(...['form-row', 'mb-0']);

        let containerColumn = document.createElement("div");
        containerColumn.classList.add(...['col-xl-12', 'mb-3']);
        container.append(containerColumn);

        let formGroup = document.createElement("div");
        formGroup.classList.add(...['form-group']);
        containerColumn.append(formGroup);

        let label = document.createElement("label");
        label.classList.add(...['form-label']);
        label.textContent = this.resourcesHandler.get('Sorting');
        formGroup.append(label);

        let input = document.createElement("input");
        input.classList.add(...['form-control']);
        input.id = this.sortingId;
        formGroup.append(input);

        let optionsContainer = document.getElementById(this.chartOptionsSettingsContainer);
        optionsContainer.appendChild(container);

        //INIT
        $('#' + this.sortingId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            syncValueAndText: false,
            ignoreCase: true,
            appendTo: '#' + this.sortingId,
            dataSource: this.sortingTypes,
            change: (e) => {
                let value = e.sender.value();
                console.log(value);
            }
        });
    }

    _addColorPalleteOptions() {
        //todo last
        let masterPaletteContainer = document.createElement("div");
        masterPaletteContainer.classList.add(...['d-flex', 'flex-column']);
        masterPaletteContainer.style.maxHeight = '100px';
        masterPaletteContainer.style.overflow = 'hidden';
        masterPaletteContainer.style.overflowY = 'auto';
        masterPaletteContainer.style.scrollBehavior

        this.colorPalettes.forEach(palette => {

            let paletteContainer = document.createElement("div");
            paletteContainer.classList.add(...['d-flex', 'flex-row', 'mb-1']);

            let paletteCheckbox = document.createElement('input');
            paletteCheckbox.type = 'checkbox';
            paletteCheckbox.id = palette.id;
            paletteCheckbox.style.marginRight = '10px';
            paletteContainer.appendChild(paletteCheckbox);

            let paletteColorsRow = document.createElement("div");
            paletteColorsRow.classList.add(...['d-flex', 'flex-row']);
            palette.colors.forEach(color => {
                let colorDiv = document.createElement("div");
                colorDiv.style.backgroundColor = color;
                colorDiv.style.height = '10px';
                colorDiv.style.width = '10px';

                paletteColorsRow.appendChild(colorDiv);
            });
            paletteContainer.appendChild(paletteColorsRow);

            masterPaletteContainer.appendChild(paletteContainer);
        });

        let optionsContainer = document.getElementById(this.chartOptionsSettingsContainer);
        optionsContainer.appendChild(masterPaletteContainer);
    }
}